var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBack = function SvgBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 13,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#back_svg__a)",
    d: "M.5 0h12v12H.5z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "back_svg__a",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#back_svg__b",
    transform: "scale(.01)"
  })), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAAAXNSR0IArs4c6QAAAvVJREFUeAHtnU1rFEEQhseP37Hd1Qt6FFSIx/29Kp5yyC3/Rk9+gMgGPEQaFhmXV5iaUKnZmScQyBY1VdXPk5neS+8OAz8QgAAEIAABCEBgxQSerHhtl7O01trOzD7WWn+Y2dHMbszs1eWsYEWT1lqvzOybmd2Pf0spP5HyyKK7jNNd8Y+MkZibRx5pu+0myOiSjsMwsK9E/5tMlNGF/IqeZfP1HTLuW2ufNg8sEoBHhpl93+12LXKeTdfe7/dv1Lup0Qb+d2PvG32Xt2lgkYtHRiRdZ21kOIFFpiMjkq6zNjKcwCLTkRFJ11kbGU5gkenIiKTrrI0MJ7DIdGRE0nXWRoYTWGQ6MiLpOmsjwwksMh0ZkXSdtZHhBBaZjoxIus7ayHACi0xHRiRdZ21kOIFFpiMjkq6zNjKcwCLTkRFJ11kbGU5gkenIiKTrrI0MJ7DIdGRE0nXWRoYTWGQ6MiLpOmsjwwksMh0ZkXSdtZHhBBaZjoxIus7ayHACi0xHRiRdZ20ze9mPh6mTSucxTi454c5JL6V8OAevXiNjDt0Z15jZFyVgHEPGDLBzLzGzz2P46u+TkHdze3Cdg4CZvVcSzmPcJQ6oD0ltrb1gU38IwYBrSymvzezr+V2hXvP4ChCgSiJFUUmOISVZgGqPFEUlOYaUZAGqPVIUleQYUpIFqPZIUVSSY0hJFqDaI0VRSY4hJVmAao8URSU5hpRkAao9UhSV5BhSkgWo9khRVJJjSEkWoNojRVFJjiElWYBqjxRFJTmGlGQBqj1SFJXkGFKSBaj2SFFUkmNISRag2iNFUUmOISVZgGqPFEUlOYaUZAGqPVIUleQYUpIFqPZIUVSSY0hJFqDaI0VRSY55v3q1H8dLHnn97Z1SrtdPZAErnPr4qrXeDcPwbAEjr3+EKVJKKb8Ph8Pz9dNYyAonPL5uFzLqdsboUv5zjv7YWnu7HRILWunpww2u+57RH1NmdouMZQh6yia+DBFMAQEIQAACELhYAn8AblBYpTpql3YAAAAASUVORK5CYII=",
    id: "back_svg__b",
    width: 100,
    height: 100
  }))));
};
export default SvgBack;